// extracted by mini-css-extract-plugin
export var growableInput = "_3x-0";
export var tagContainer = "_3x-2";
export var textInput = "_3x-1";